export const data = [
  {
    question:
      'آیا دستگاه از NFC پشتیبانی میکند؟ ماژول NFC کدام قسمت گوشی قرار دارد؟ چطور باید NFC گوشی را فعال کرد؟',
    answer:
      'برای بررسی پشتیبانی NFC در گوشی های اندرویدی با ورود به بخش تنظیمات و جستجوی کلمه NFC از این مورد اطلاع پیدا کنید. در مورد گوشی های آیفون تمام گوشی ها از آیفون 7 به بالا از NFC پشتیبانی میکند. در مورد مکان دقیق ماژول NFC گوشی توضیح یکسانی وجود ندارد اما در 90 درصد تلفن های همراه در قسمت بالایی گوشی کنار دوربین قرار دارد. فعال سازی NFC مشابه فعالسازی سایر ماژول ها مانند بلوتوث و وای فای میباشد و از قسمت تنظیمات گوشی روشن یا خاموش میشود.',
  },
  {
    question:
      'ظرفیت باتری دستگاه حدودا چند تست را شامل میشود؟ و در صورت ضعیف شدن باتری اسکن دستگاه چه وضعیتی خواهد داشت؟',
    answer:
      'ظرفیت کامل باتری شامل 880 اسکن میباشد و در صورت ضعیف شدن باتری هیچ داده ای بین گوشی و دستگاه منتقل نخواهد شد و پیغام LP روی صفحه دستگاه ظاهر میشود بهتر است همیشه چند باتری اضافه برای دستگاه وجود داشته باشد تا با تعویض باتری مجددا فرایند اسکن به درستی انجام شود.',
  },
  {
    question: 'اگر باتری از دستگاه فریسنس خارج شود چه اتفاقی می افتد؟',
    answer:
      'با بیرون آمدن باتری، تاریخ و ساعت دستگاه در همان تاریخ و ساعت ثابت می ماند. در این حالت یک بار با اپلیکیشن اسکن کنید تا تاریخ و ساعت دستگاه شما بروز شود یا از طریق دکمه های دستگاه اقدام کنید. بهتر است این کار را قبل از تست قند خون انجام دهید تا زمان تست صحیح ثبت شود.',
  },
  {
    question:
      'آیا پزشک هم می تواند دستگاه من را اسکن کند و اطلاعات آن را ببیند؟',
    answer:
      'بله! شما در هنگام مراجعه حضوری به پزشک می توانید دستگاه خود را به همراه خود ببرید ، پزشک با اپلیکیشن مخصوص خود، دستگاه شما را اسکن کرده و در کمتر از چند ثانیه می تواند گزارش جامعی از تست های قند خون شما را ببیند.',
  },
  {
    question: 'آیا اپلیکیشن پزشک و بیمار تفاوت دارند؟',
    answer:
      'بله! دستگاه فریسنس دارای دو اپلیکیشن جدا از هم میباشد که یکی مخصوص پزشک و دستیار پزشک و دیگری ویژه افراد مبتلا به دیابت است حتما توجه فرمایید با توجه اینکه در کدام از این دو دسته قرار میگیرید اقدام به دانلود اپلیکیشن نمایید.',
  },
  {
    question:
      'رفتار اپلیکیشن با عدم تنظیم بودن تاریخ دستگاه به چه صورت میباشد؟',
    answer:
      'توجه فرمایید حتما تاریخ دستگاه صحیح باشد از دو طریق این امکان وجود دارد اول به وسیله خود دستگاه و دوم پس از اسکن توسط اپلیکیشن دقت داشته باشید تنظیم تاریخ دستگاه به وسیله اسکن تنظیم تاریخ تست های گرفته شده تا زمان اسکن را شامل نمیشود و پس از اسکن اول به بعد تاریخ تست ها به درستی ثبت خواهد شد',
  },
  {
    question: 'از چه طریقی میتوان اپلیکیشن ها را دانلود کرد؟',
    answer:
      'از طریق وبسایت freesens.ir میتوانید اقدام به دانلود تمام نسخه ها کنید. در غیر این صورت برای نصب نسخه اندروید میتوانید از کافه بازار یا پلی استور نیز اقدام به نصب نمایید برای نصب اپلیکیشن های آیفون مارکت سیبچه و روش نصب مستقیم تست فلایت وجود دارد.',
  },
  {
    question:
      'در صورت نداشتن سیبچه و سایر مارکت های ایرانی آیا اپلیکیشن روی iOS قابل نصب است؟',
    answer:
      'بله میتوانید از روش نصب مستقیم از طریق TestFlight اقدام به نصب اپلیکیشن نمایید برای اطلاعات بیشتر روی لینک های زیر کلیک کنید',
    blueText: 'نصب مستقیم اپلیکیشن ویژه پزشکان و دستیاران پزشک iOS  ',
    blueText2: ' نصب مستقیم اپلیکیشن ویژه مبتلایان به دیابت iOS',
    redirectBlue: 'https://freesens.ir/freesens-doctor-ios-direct-link',
    redirectBlue2: 'https://freesens.ir/freesens-patient-ios-direct-link',
  },
  {
    question: 'برای استفاده از اپلیکیشن فریسنس به چه نکاتی باید توجه کرد؟',
    answer:
      'اول اینکه بررسی شود گوشی دارای ماژول NFC میباشد (رجوع شود به سوال اول) دوم برنامه متناسب با کاربرد بر اساس پزشک یا دستیار پزشک یا بیمار دانلود شود سوم اتصال به اینترنت و خاموش کردن VPN برای تجربه بهتر کاربری.',
  },
  {
    question: 'منظور از دستیار پزشک چیست؟',
    answer:
      'دستیار پزشک به دو بخش تقسیم میشود حالت معمولی و مرکز اسکن در حالت معمولی دستیار پزشک شامل منشی یا پرستار و.... میشود و در مورد مرکز اسکن این مورد اشاره به مراکز فروش اعم از خرده فروشی یا نمایندگی فریسنس و غیره... میباشد.',
  },
  {
    question: 'دستگاه ارور LP را نمایش نمیدهد ولی اسکن با خطا مواجه میشود',
    answer:
      'در برخی موارد به دلیل حساسیت ماژول NFC به فاصله چنانچه قاب گوشی ضخیم باشد یک بار فرایند اسکن را با خارج کردن گوشی از قاب انجام دهید (در تعداد کمی از گوشی ها فرایند بدون خطای اسکن با اتصال دستگاه فریسنس به صفحه نمایش به جای پشت دستگاه اتفاق میافتد) چنانچه همچنان مشکلی در اسکن وجود داشت به عنوان راه حل نهایی یک بار باتری دستگاه فریسنس را خارج نموده و مجددا وارد دستگاه نمایید .',
  },
  {
    question: 'آیا اپلیکیشن بر روی کامپیوتر، لپ تاپ و تبلت قابل اجرا است؟',
    answer:
      'به غیر از موارد مربوط به فرایند اسکن که نیازمند ماژول NFC و اسکن توسط اپلیکیشن فریسنس میباشد، باقی موارد مانند نمایش گزارش ها و غیره از طریق همه پلتفرم ها قابل دسترسی میباشد.',
  },
  {
    question:
      'شماره کد چهار رقمی برای فرد ارسال نمی شود. چه اقدامی باید انجام شود؟',
    answer:
      'پس از بررسی اتصال اینترنت و کنترل قطع بودن VPN ممکن است دریافت پیامک های تبلیغاتی و غیره (در این مورد شامل کد تایید 4 رقمی) از طریق پنل پیامکی توسط صاحب تلفن همراه مسدود شده باشد که با ارسال عدد ۱۲ به سرشماره 100024837000 میتوانید برای رفع مسدودی احتمالی اقدام نمایید.',
  },
  {
    question: 'پس از اسکن مدام پیغام تنطیم تاریخ دستگاه نمایش داده میشود',
    answer:
      'این مشکل زمانی اتفاق میافتد که ساعت گوشی مطابق با منطقه جغرافیایی ایران تنظیم نشده باشد برای حل این مشکل پس از بررسی اتصال اینترنت گوشی زمان گوشی را از حالت دستی به اتوماتیک تغییر دهید.',
  },
];
